// extracted by mini-css-extract-plugin
module.exports = {"card":"GiftCard_card__1UKw5","cardTitle":"GiftCard_cardTitle__xGVxU","cardSubtitle":"GiftCard_cardSubtitle__BfkLX","cardImage":"GiftCard_cardImage__jwHZQ"};